import axios from "../../../axios";
export const getDeliveryInfoList = () => {
  const response = axios.get(`orders/delivery-slots/`);
  return response;
};

export function paymentCheckout(payload: any) {
  const response = axios.post(`orders/checkout/`, payload);
  return response;
}
export function paymentVerification(payload: any) {
  const response = axios.post(`orders/verifypayment/`, payload);
  return response;
}

export const getPastOrderDataDetails = (uuid: any) => {
  const response = axios.get(`orders/past-orders/${uuid}`);
  return response;
};

export const getCouponList = () => {
  const response = axios.post(`orders/coupons/`);
  return response;
};

export const getAddressChange = (payload: any) => {
  const response = axios.post(`orders/address-change/`, payload);
  return response;
};
